module.exports = __webpack_public_path__ + "img/xiangmu.ce925047.png";